<template>
  <v-btn
    class="social-link"
    :href="validUrl()"
    fab
    tile
    small
    link
    depressed
    target="_blank"
    color="button"
  >
    <v-icon :color="color">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
import { validateUrl } from '@/helpers/utils';

export default {
  props: {
    link: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'white',
    },
  },

  methods: {
    validUrl() {
      return validateUrl(this.link);
    },
  },
};
</script>

<style lang="scss" scoped>
.social-link {
  border-radius: 4px;
  margin-left: 16px;
}
</style>
